// index
const index = resolve => {
  require.ensure(['../views/index'], () => {
    resolve(require('../views/index'))
  })
}

export const routes = [{
    path: '/',
    redirect: '/index'
  },
  {
    path: '/index/:schoolId',
    component: index,
    name: 'index',
    meta: {
      title: '气象站数据大屏',
      content: '-由传感器、节点，网关等组成的智能环境监测系统，可以实时收集大气温湿度、二氧化碳、大气压、光照，土壤温湿度、EC值等数据并以图表清晰呈现。',
      path: 'index',
      auth: true,
      keepAlive: false
    }
  },
  {
    path: '*',
    redirect: '/index'
  }
]

export default routes
